module.exports = __webpack_public_path__ + "static/ahmedabad-06dd0af3a04809246fedf56e6e7ab0a3.png";